import { render, staticRenderFns } from "./LeadEventItem.vue?vue&type=template&id=01359204&scoped=true&"
import script from "./LeadEventItem.vue?vue&type=script&lang=js&"
export * from "./LeadEventItem.vue?vue&type=script&lang=js&"
import style0 from "./LeadEventItem.vue?vue&type=style&index=0&id=01359204&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01359204",
  null
  
)

export default component.exports